import React from 'react';
import { COLOR } from '@src/styles/color';
import { useTranslation } from 'react-i18next';
import {
  StyledBadgeContainer,
  StyledDot,
  StyledBadgeText,
} from './index.style';

const BADGE_CONFIG = {
  current: { dotColor: COLOR.green, bgColor: COLOR.charcoal },
  old: { dotColor: COLOR.green, bgColor: COLOR.charcoal },
  expired: { dotColor: COLOR.redPrimary, bgColor: COLOR.charcoal },
};

const PackageStatusBadge = ({
  type = 'current',
  isExpired = false,
  isTwoPackage = false,
}) => {
  const { t } = useTranslation();
  const statusType = isExpired ? 'expired' : type;
  const config = BADGE_CONFIG[statusType];

  const getLabel = () => {
    if (isExpired) return t('expiredV2');
    if (type === 'old') return t('oldPackage');
    if (isTwoPackage) return t('currentPackageV2');
    return t('activePackage');
  };

  return (
    <StyledBadgeContainer bgColor={config.bgColor}>
      <StyledDot dotColor={config.dotColor} />
      <StyledBadgeText isExpired={isExpired}>{getLabel()}</StyledBadgeText>
    </StyledBadgeContainer>
  );
};

export default PackageStatusBadge;
